var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-m-quiz__loading"},[_c('div',{staticClass:"dd-m-quiz__loading__item dd-m-quiz__loading__item--1"}),_vm._v(" "),_c('div',{staticClass:"dd-m-quiz__loading__item dd-m-quiz__loading__item--2"})])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1be7e6a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/quiz/quiz-loading.vue
// module id = 299
// module chunks = 2 11